export default (url = window.location.href) => {
  if (!url) {
    return 'bnnvara';
  }

  const { hostname } = new URL(url);
  const subDomain = hostname.replace('www.', '').split('.')[0];

  const sitename =
    {
      oml: 'overmijnlijk',
      kvk: 'kinderenvoorkinderen',
      dwdd: 'dewerelddraaitdoor',
    }[subDomain] || subDomain;

  return sitename;
};
